import { shorthands, tokens } from '@fluentui/react-components';

export const getAdStepStyle = () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '574px',
    '& .text-input-container': {
      width: '100% !important',
    },

    '& .call-to-action-dropdown': {
      width: '100%',
    },
    '& .text-assets-collection-container': {
      width: '100%',
    },
    '& .linkedin-ad-section .fui-FluentProvider:empty': {
      display: 'none', // Hide when empty to avoid unreasonable gap
    },
    '& .linkedin-ad-section .banner-container': {
      margin: '0px', // Remove margin to avoid unreasonable gap
    },
    '& .introductory-text-section': {
      '& .ms-TextField-fieldGroup': {
        minHeight: '70px',
      },
    },
  },

  content: {
    display: 'flex',
    gap: '32px',
    alignItems: 'start',
  },

  rightStyles: {
    position: 'sticky',
    top: '-16px',
    width: '542px',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '574px',

    ...shorthands.gap(tokens.spacingVerticalS),
    '& .panel-title > a:focus': {
      outline: 'thin dotted',
    },
  },
});

